import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import bookingActions from 'actions/bookings/actions'

const ViewProposal = ({ proposalId, data: { space, spaceLink, spaceType, stay, guests, notes, attachments = [], total }, handleClose, closeTitle, getClientProposalDetails }) => {
  useEffect(() => {
    getClientProposalDetails({ id: proposalId })
  }, [])
  return (
    <div className="bg-white md:my-10 w-full md:w-1/2 shadow-md md:rounded-lg m-auto">
      <div className="p-10">
        <div className="header">
          <div className="flex items-center text-primary-orange cursor-pointer" onClick={handleClose}>
            <i className="fa fa-long-arrow-left mr-3" aria-hidden="true"></i>
            <p className="text-xs">{closeTitle || 'Back to Leads & Bookings Table'}</p>
          </div>
          <h2 className="text-2xl font-semibold my-3">Review Booking Details</h2>
        </div>
        <div className="body">
          <div className="flex flex-wrap my-5">
            <div className="w-2/3 py-5">
              <p className="font-semibold">Space</p>
              <a className="text-sm text-primary-orange" href={spaceLink}>{space}</a>
            </div>
            <div className="w-1/3 py-5">
              <p className="font-semibold">Space Type</p>
              <p className="text-sm text-primary-lightgray">{spaceType}</p>
            </div>
            <div className="w-2/3 py-5">
              <p className="font-semibold">Planning to Stay On</p>
              <p className="text-sm text-primary-lightgray">{stay}</p>
            </div>
            <div className="w-1/3 py-5">
              <p className="font-semibold">Guests</p>
              <p className="text-sm text-primary-lightgray">{`${guests} Guests`}</p>
            </div>
          </div>
          <div className="my-5">
            <p className="font-semibold">Notes</p>
            <p className="text-sm text-primary-lightgray">{notes || 'No notes.'}</p>
          </div>
          <div className="my-5">
            <p className="font-semibold">Attachment</p>
            <p className="text-sm text-primary-lightgray max-w-md">
              Please be careful when opening attachments from unkown sources.
              Flyspace is not responsible for any harmful files you might receive.
            </p>
            <ul className="my-5">
              {attachments.map((attachment, key) => (
                <li className="flex my-2 py-1 px-2 md:w-4/5 w-full bg-secondary-lightgray justify-around items-center" key={key}>
                  <i className="fa fa-file-o mx-2 text-primary-lightgray" aria-hidden="true"></i>
                  <small className="flex-1 text-primary-orange">{attachment.name}</small>
                  <a href={attachment.path} download target='_blank' rel="noreferrer">
                    <i className="fa fa-download text-primary-lightgray" aria-hidden="true"></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="my-5">
            <p className="font-semibold">Total Amount</p>
            <p className="text-3xl text-primary-orange">{total}</p>
          </div>
        </div>
        <div className="footer mt-5">
          <p className="text-sm text-primary-lightgray">
              I agree to FlySpaces&apos; <span className="text-primary-orange">
              <a href="#">Cancellation Policy</a> and <a href="#">Refund Policy.</a>
            </span>
          </p>
          <p className="text-sm text-primary-lightgray">
            I also agree to pay the total amount shown,
            which includes service fees.
          </p>
          <div className="mt-5">
            <Link className="btn-primary py-3 px-10 rounded" to={`/client/transaction/pay/${proposalId}`}>PAY NOW</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

ViewProposal.propTypes = {
  data: PropTypes.object,
  handleClose: PropTypes.func,
  closeTitle: PropTypes.string,
  getClientProposalDetails: PropTypes.func,
  proposalId: PropTypes.number
}

const mapStateToProps = ({ bookings }) => ({
  data: bookings.proposalDetails,
});

const mapDispatchToProps = {
  getClientProposalDetails: bookingActions.getClientProposalDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewProposal)
